import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { inject } from '@angular/core';
import { SnackService } from './snack.service';
import { serverurl } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserGateConfigService {
    private http = inject(HttpClient);
    private snack = inject(SnackService);

    async saveConfig(): Promise<boolean> {
      return await new Promise((resolve) => {
        this.http.delete(`${serverurl}/`).subscribe({
          next: (data) => {
            resolve(true);
          },
          error: (error) => {
            this.snack.error(error)
            resolve(false);
          }
        });
      });
    }
}
